import z from 'zod';
import { OpenApiZodAny, generateSchema } from '@anatine/zod-openapi';
import { SchemaObject } from 'openapi3-ts';
import { RedocSchemaObject, extendApi } from '../openapi';
import { language } from './string';

export function i18nAttributes<T extends OpenApiZodAny>(
  localizedPropertiesType: T,
  openapiOverride?: Partial<RedocSchemaObject>,
) {
  const openapi = localizedPropertiesType.metaOpenApi as SchemaObject | undefined;
  const examples = openapi?.examples ? openapi?.examples : [openapi?.example, openapi?.example];

  return extendApi(z.record(language, localizedPropertiesType), {
    type: 'object',
    description: 'Localized attributes (displayed to the members)',
    additionalProperties: {
      ...generateSchema(localizedPropertiesType),
      'x-additionalPropertiesName': 'language key',
    },
    minProperties: 1,
    example: {
      en: examples[0] ?? { name: 'My product' },
      fr: examples[1] ?? examples[0] ?? { name: 'Mon produit' },
    },
    ...openapiOverride,
  } as RedocSchemaObject);
}
